import TextInput from 'components/refinedev/TextInput';
import TextareaInput from 'components/refinedev/TextareaInput';
import Section from 'components/surface/Section';

const ConversationForm = () => {
  return (
    <div className="flex flex-row gap-2 w-full">
      <Section title="Tiêu đề và tóm tắt" bodyProps={{className: 'flex flex-col gap-2'}}>
        <ConversationForm.GeneralInfo />
      </Section>
    </div>
  );
};

ConversationForm.GeneralInfo = () => (
  <>
    <TextInput source="name" label="Tiêu đề" />
    <TextareaInput source="description" label="Mô tả" />
  </>
);

export const transformBeforeSave = inputData => {
  let data = {
    ...inputData,
    members: inputData.members
      ? JSON.stringify(inputData.members?.map?.(m => m.id) || [])
      : undefined,
  };
  return data;
};

ConversationForm.transformBeforeSave = transformBeforeSave;

export default ConversationForm;
